import React from 'react';

import Context from './Context';
import { ContextType, ProductConfig } from './types';
import { ACL } from '../../types';

type AccessFn = (key: ACL.FeatureKey) => boolean;

const defaultProductConfig: ProductConfig = {
  links: [],
  features: [],
  filters: [],
  featureFlags: [],
};

export const MockACLProvider = ({
  mockValue,
  children,
  productType,
  featureFlagValue,
  allowAccess,
  productConfig,
}: {
  mockValue?: Partial<ContextType>;
  children: React.ReactNode;
  productType?: ACL.ProductType;
  featureFlagValue?: boolean;
  allowAccess?: AccessFn;
  productConfig?: ProductConfig;
}) => {
  const hasAccess: AccessFn =
    typeof allowAccess === 'function'
      ? allowAccess
      : (_: ACL.FeatureKey) => true;

  const value: Partial<ContextType> = {
    // Set default value for ACL Context
    setUser: () => null,
    hasAccess,
    getProductType: () => productType ?? ACL.PRODUCT_TYPE.PTS,
    getProductConfig: () => productConfig ?? defaultProductConfig,
    hasFeatureFlag: () => featureFlagValue ?? false,
    ...(mockValue ? mockValue : {}),
  };
  return (
    <Context.Provider value={value as ContextType}>{children}</Context.Provider>
  );
};
